/* tslint:disable */
import { Packing } from './packing';
import { SavePackingLayer_packingLayers } from './save-packing-layer-_packing-layers';

/**
 */
export class SavePackingLayer {
    packing?: Packing;
    packingLayers?: SavePackingLayer_packingLayers[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/save-packing-layer.ts